import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=e7c44db6&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7c44db6')) {
      api.createRecord('e7c44db6', component.options)
    } else {
      api.reload('e7c44db6', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=e7c44db6&", function () {
      api.rerender('e7c44db6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BnMwcmWGIpFp/JS/comp/pricelist.vue"
export default component.exports